import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export const usePropertyData = () => {
  const [provinces, setProvinces] = useState<any[]>([]);
  const [zones, setZones] = useState<any[]>([]);
  const [propertyTypes, setPropertyTypes] = useState<any[]>([]);
  const [propertyStates, setPropertyStates] = useState<any[]>([]);
  const [propertyStatuses, setPropertyStatuses] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      // Fetch provinces
      const { data: provincesData, error: provincesError } = await supabase
        .from('provinces')
        .select('*')
        .order('name', { ascending: true });

      if (provincesError) throw provincesError;
      setProvinces(provincesData || []);

      // Fetch zones
      const { data: zonesData, error: zonesError } = await supabase
        .from('zones')
        .select('*, provinces(*)')
        .order('name', { ascending: true });

      if (zonesError) throw zonesError;
      setZones(zonesData || []);

      // Fetch property types
      const { data: typesData, error: typesError } = await supabase
        .from('property_types')
        .select('*')
        .order('name', { ascending: true });

      if (typesError) throw typesError;
      setPropertyTypes(typesData || []);

      // Fetch property states
      const { data: statesData, error: statesError } = await supabase
        .from('property_states')
        .select('*')
        .order('name', { ascending: true });

      if (statesError) throw statesError;
      setPropertyStates(statesData || []);

      // Fetch property statuses
      const { data: statusesData, error: statusesError } = await supabase
        .from('property_statuses')
        .select('*')
        .order('name', { ascending: true });

      if (statusesError) throw statusesError;
      setPropertyStatuses(statusesData || []);

    } catch (err: any) {
      console.error('Error fetching property data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    provinces,
    zones,
    propertyTypes,
    propertyStates,
    propertyStatuses,
    loading,
    error
  };
};